export default __webpack_public_path__ + "static/media/fr1000-2.098c6e9e.webp";